import * as React from 'react';
import { translate } from 'components/translate-hoc';
import DatePicker from 'react-datepicker';
import InputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';

import { getModeClass } from 'utils/css';
import { ICommonFieldProps } from './fields.types';
import { DateFormats, EN_US } from './fields.constants';

export class DateField extends React.Component<ICommonFieldProps> {
    private onChange(year: string | number, month: string | number, date: string | number): void {
        this.props.input.onChange(`${year}-${month}-${date}`);
    }

    private handleInputChange = (data: Date | null): void => {
        if (!data) {
            return;
        }

        const year = data.getFullYear();
        const date: string | number = this.format(data.getDate());
        const month: string | number = this.format(data.getMonth() + 1);

        this.onChange(year, month, date);
    };

    private format(value: number) {
        return value < 10 ? '0' + value : value;
    }

    private getLabelKey(): string {
        const { translatePrefix, input } = this.props;
        return `${translatePrefix}${input.name}`;
    }

    private getInputMask = () => {
        const { activeLanguageCode } = this.props;
        return activeLanguageCode === EN_US ? DateFormats.MMDDYYYY : DateFormats.DDMMYYYY;
    }

    public render(): JSX.Element {
        const {
            dangerouslyTranslateWithHTML: translateKey,
            translatePrefix,
            input: { value },
            meta,
            shouldInheritStyles
        } = this.props;

        const labelText = translateKey(this.getLabelKey());
        const isWarning = meta.error && meta.submitFailed;
        const errorMessage = isWarning ? translateKey(`${translatePrefix}${meta.error.message}`) : '';
        const className = getModeClass('sitegen-date-picker', shouldInheritStyles);

        return (
            <div className={className}>
                <div className={`${className}__label`}>{labelText}</div>
                <div className={`${className}__container`}>
                    <DatePicker
                        dateFormat={this.getInputMask()}
                        selected={value ? new Date(value) : null}
                        customInput={
                            <InputMask
                                alwaysShowMask
                                mask="99/99/9999"
                                maskPlaceholder={this.getInputMask().toUpperCase()}
                            />
                        }
                        onChange={(date) => this.handleInputChange(date)} />
                    <div className={`${className}__error`}>{errorMessage}</div>
                </div>
            </div>
        );
    }
}

export default translate()(DateField);
